module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_1.5da8e12d.png";